import styled from 'styled-components';
import { media } from 'designsystem/index';

const ButtonWrapper = styled.div`
  position: absolute;
  display: flex;
  justify-content: space-between;
  width: 100%;
  top: 410px;
  z-index: 25;
  
  ${media.desktop`
    top: 545px;
  `};
`;

export default ButtonWrapper;



// WEBPACK FOOTER //
// ./src/kentico-blocks/ImageSlider/ButtonWrapper.jsx